import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview', 'template']

  connect() {
    this.files = new DataTransfer()
  }

  add(event) {
    const newFiles = Array.from(event.target.files)

    newFiles.forEach((file) => {
      this.files.items.add(file)
      this.addPreview(file)
    })

    this.syncInput()
    event.target.value = ''
  }

  addPreview(file) {
    const item = document.createElement('div')
    item.className = 'position-relative'
    item.dataset.filename = file.name

    if (file.type.startsWith('image/')) {
      const img = document.createElement('img')
      img.className = 'rounded border'
      img.style.cssText = 'width: 80px; height: 80px; object-fit: cover;'

      const reader = new FileReader()
      reader.onload = (e) => {
        img.src = e.target.result
      }
      reader.readAsDataURL(file)

      item.appendChild(img)
    } else {
      const fileBox = document.createElement('div')
      fileBox.className =
        'rounded border bg-light d-flex flex-column align-items-center justify-content-center p-2'
      fileBox.style.cssText = 'width: 80px; height: 80px;'

      const icon = document.createElement('i')
      icon.className = `bi ${this.iconForFile(file)} fs-4 text-muted`
      fileBox.appendChild(icon)

      const name = document.createElement('small')
      name.className = 'text-truncate w-100 text-center text-muted'
      name.style.fontSize = '0.65rem'
      name.textContent = file.name
      fileBox.appendChild(name)

      item.appendChild(fileBox)
    }

    const removeBtn = document.createElement('button')
    removeBtn.type = 'button'
    removeBtn.className =
      'btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle p-0 d-flex align-items-center justify-content-center'
    removeBtn.style.cssText =
      'width: 20px; height: 20px; transform: translate(25%, -25%);'
    removeBtn.innerHTML = '<i class="bi bi-x small"></i>'
    removeBtn.dataset.action = 'click->file-attachments#remove'
    removeBtn.dataset.filename = file.name

    item.appendChild(removeBtn)
    this.previewTarget.appendChild(item)
  }

  remove(event) {
    event.preventDefault()
    const filename = event.currentTarget.dataset.filename

    const newFiles = new DataTransfer()
    for (let i = 0; i < this.files.files.length; i++) {
      if (this.files.files[i].name !== filename) {
        newFiles.items.add(this.files.files[i])
      }
    }
    this.files = newFiles

    const item = this.previewTarget.querySelector(
      `[data-filename="${filename}"]`
    )
    if (item) item.remove()

    this.syncInput()
  }

  syncInput() {
    this.inputTarget.files = this.files.files
  }

  iconForFile(file) {
    const type = file.type
    if (type.startsWith('image/')) return 'bi-file-image'
    if (type === 'application/pdf') return 'bi-file-pdf'
    if (type.includes('word') || type.includes('document'))
      return 'bi-file-word'
    if (type.includes('sheet') || type.includes('excel')) return 'bi-file-excel'
    if (type.includes('zip') || type.includes('archive')) return 'bi-file-zip'
    return 'bi-file-earmark'
  }
}
